import React from 'react';
import { NavBar, Footer } from 'components';
import { makeStyles } from '@material-ui/core';


interface IProps {
    children: React.ReactNode
}

const useStyles = makeStyles(theme => ({
    footer: {
        marginTop: theme.spacing(2)
    }
}))

let Layout = ({ children }: IProps) => {
    let classes = useStyles();

    return (
        <>
            <NavBar />
            {children}
            <footer className={classes.footer}>
                <Footer />
            </footer>
        </>
    )
}

export default Layout;